import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { TestimonialCard } from './TestimonialCard';
import { TallyEmbed } from './TallyEmbed';
export function TransformationQuestionnaire() {
  const testimonials = [{
    name: 'Yair Mustafa',
    condition: 'Client',
    quote: "At 45, I thought low energy and declining performance were just part of aging... The course goes beyond just testosterone - it's a complete system for male hormone optimization. My wife has noticed the difference in my mood and vitality. I only wish I had found this years ago.",
    result: 'Overcoming Aging'
  }, {
    name: 'Susan',
    condition: 'Client',
    quote: "Brenden's call was so thorough and we did as deep a dive into my health as the time would allow. I look forward to beginning the journey with him especially reading about the training protocols offered as I have hit a bit of a wall with mine... Ali, You and Brenden - the best triple threat in the Healthspan/Lifespan space.",
    result: 'Thorough Consultation & Protocol'
  }, {
    name: 'Michael M.',
    condition: 'Client',
    quote: "I've gone from thinking about my funeral to planning hiking trips. I can't thank you guys and the team enough.",
    result: 'Post-Osteoarthritis Transformation'
  }, {
    name: 'Mike S.',
    condition: 'Client',
    quote: "I truly believe that if you aren't listening to Ali and his team, and you're listening to anyone else about peptides and pharmacology, you're wasting your time. He is truly in a league of its own. He is the cheat codes for my body.",
    result: 'Unrivaled Authority & Performance Boost'
  }, {
    name: 'triangulair',
    condition: 'Client',
    quote: "good job, with your tips (elevated bed + sleep more on the right side) i had 8 awakenings during the night but much more REM sleep than usual + lower HR! i'll do the report later.",
    result: 'Direct Coaching Results on Sleep'
  }];
  return <section id="questionnaire" className="relative py-24 overflow-hidden" data-id="element-266">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 via-fuchsia-950/80 to-cyan-950/80" data-id="element-267"></div>
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-slate-900 to-transparent pointer-events-none" data-id="element-268"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-fuchsia-500/5" data-id="element-269"></div>
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" data-id="element-270"></div>
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-fuchsia-500/10 rounded-full blur-3xl" data-id="element-271"></div>
      <div className="max-w-7xl mx-auto px-6 relative" data-id="element-272">
        <div className="text-center mb-20 max-w-4xl mx-auto" data-id="element-273">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-274">
            Ready to Start Your Transformation?
          </h2>
          <p className="text-xl text-cyan-100 mb-6 font-medium leading-relaxed" data-id="element-275">
            Fill out the questionnaire below. You will then be taken to a
            beautiful page which shows you{' '}
            <span className="underline" data-id="element-276">
              exactly how we will help you achieve your transformation
            </span>
            .
          </p>
          <div className="bg-slate-800/60 backdrop-blur-sm border border-fuchsia-500/30 rounded-2xl p-6 inline-block" data-id="element-277">
            <p className="text-lg text-white mb-2" data-id="element-278">
              <span className="font-bold text-cyan-400" data-id="element-279">
                Investment Required:
              </span>{' '}
              $1,500 for your first comprehensive consultation
            </p>
            <p className="text-sm text-fuchsia-300 font-semibold" data-id="element-280">
              Fully creditable towards your complete transformation program
            </p>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-281">
          <div className="lg:col-span-1 space-y-6 lg:order-1 order-2" data-id="element-282">
            <div className="lg:sticky lg:top-24 space-y-6" data-id="element-283">
              {testimonials.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} data-id="element-284" />)}
            </div>
          </div>
          <div className="lg:col-span-2 lg:order-2 order-1" data-id="element-285">
            <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-2xl border border-fuchsia-500/20 relative overflow-hidden sticky top-24" data-id="element-286">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-fuchsia-500/5 rounded-2xl" data-id="element-287"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-cyan-500/10 to-transparent rounded-full blur-3xl" data-id="element-288"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-fuchsia-500/10 to-transparent rounded-full blur-3xl" data-id="element-289"></div>
              <div className="relative" data-id="element-290">
                <div className="text-center mb-8" data-id="element-291">
                  <h3 className="text-2xl font-bold text-white mb-3" data-id="element-292">
                    Transformation Questionnaire
                  </h3>
                  <p className="text-cyan-200 font-medium" data-id="element-293">
                    Tell us about your health goals and challenges
                  </p>
                </div>
                <TallyEmbed data-id="element-294" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-cyan-950/50 pointer-events-none" data-id="element-295"></div>
    </section>;
}